import { render, staticRenderFns } from "./CodePanel.vue?vue&type=template&id=a3a1c486&"
import script from "./CodePanel.vue?vue&type=script&lang=js&"
export * from "./CodePanel.vue?vue&type=script&lang=js&"
import style0 from "./CodePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports